import request from "@/utils/request";

// 商家管理
export const merchant = {
  // 列表
  list: (params) =>
    request({
      url: "/api/backend/merchant/list",
      method: "GET",
      params,
    }),
  // 添加
  create: (form) =>
    request({
      url: "/api/backend/merchant/add",
      method: "POST",
      data: { ...form },
    }),
  // 上下架
  changeStatus: (id) =>
    request({
      url: "/api/backend/merchant/state",
      method: "POST",
      data: {
        id,
      },
    }),
  initPassword: (id) =>
    request({
      url: "/api/backend/merchant/password/initialization",
      method: "POST",
      data: { id },
    }),
  // 删除
  delEvent: (id) =>
    request({
      url: "/api/backend/merchant/del",
      method: "POST",
      data: { id },
    }),
};

export const user = {
  // 列表
  list: (params) =>
    request({
      url: "/api/backend/users",
      method: "GET",
      params,
    }),
  pointLog: (params) =>
    request({
      url: "/api/backend/integral/log",
      method: "GET",
      params,
    }),
  pointCompensation: (data) =>
    request({
      url: "/api/backend/get/raffle",
      method: "POST",
      data,
    }),
  invitationRecord: (params) =>
    request({
      url: "/api/backend/ionvitation/list",
      method: "GET",
      params,
    }),
  userinfo: (user_id) =>
    request({
      url: "/api/backend/userInfo",
      method: "GET",
      params: { user_id },
    }),
    // excel 接口
  exportUserinfoExcel: (params) =>
    request({
      url: "/api/backend/excel/userList",
      method: "GET",
      params,
    }),
};
